var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var typography = designTokens.typography;
var themeOptions = function (theme) { return ({
    components: {
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                color: 'blue',
                disableElevation: true,
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontFamily: theme.typography.fontFamily,
                    fontSize: designTokens.typography.button.medium.size.value,
                    fontWeight: designTokens.typography.heading.sub.fontWeight.value,
                    height: '40px',
                    lineHeight: designTokens.typography.button.medium.lineHeight.value,
                    padding: "10px ".concat(designTokens.spacing[16].value),
                    textTransform: 'none',
                },
                sizeLarge: {
                    height: '48px',
                    paddingBottom: '14px',
                    paddingTop: '14px',
                    fontSize: designTokens.typography.button.large.size.value,
                    lineHeight: designTokens.typography.button.large.lineHeight.value,
                },
                sizeSmall: {
                    fontSize: designTokens.typography.button.small.size.value,
                    height: '32px',
                    lineHeight: designTokens.typography.button.small.lineHeight.value,
                    paddingBottom: designTokens.spacing[8].value,
                    paddingTop: designTokens.spacing[8].value,
                },
                text: {
                    '&:hover': {
                        backgroundColor: 'unset',
                    },
                },
                iconSizeSmall: {
                    '& > *:first-of-type': {
                        fontSize: typography.icon.small.size.value,
                    },
                },
                iconSizeMedium: {
                    '& > *:first-of-type': {
                        fontSize: typography.icon.medium.size.value,
                    },
                },
                iconSizeLarge: {
                    '& > *:first-of-type': {
                        fontSize: typography.icon.large.size.value,
                    },
                },
            },
            variants: __spreadArray(__spreadArray([], ['red', 'blue'].map(function (color) { return ({
                props: { color: color, variant: 'contained' },
                style: {
                    // Explicitely stating all selectors for backwards compatibility of Pigment
                    //  with apps that use stylebitz (sb defines some of these globally and needs to be overriden)
                    '&:visited, &:link': {
                        backgroundColor: designTokens.color[color].default.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:hover': {
                        backgroundColor: designTokens.color[color].hover.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:active': {
                        backgroundColor: designTokens.color[color].active.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:focus-visible': {
                        backgroundColor: theme.palette[color].light,
                        color: designTokens.color.shade.white.value,
                    },
                },
            }); }), true), [
                {
                    props: { color: 'blue', variant: 'outlined' },
                    style: {
                        border: "1px solid ".concat(designTokens.color.blue.default.value),
                        backgroundColor: designTokens.color.shade.white.value,
                        '&:focus-visible': {
                            backgroundColor: theme.palette.blue.light,
                            color: theme.palette.blue.contrastText,
                        },
                        '&:hover': {
                            backgroundColor: designTokens.color.blue.hover.value,
                            borderColor: designTokens.color.blue.hover.value,
                            color: theme.palette.blue.contrastText,
                        },
                        '&:active': {
                            backgroundColor: designTokens.color.blue.active.value,
                            borderColor: designTokens.color.blue.active.value,
                            color: theme.palette.blue.contrastText,
                        },
                    },
                },
                {
                    props: { color: 'blue', variant: 'text' },
                    style: {
                        '&:hover, &:focus': {
                            backgroundColor: designTokens.color.blue.default.alpha.hover.value,
                        },
                        '&:active': {
                            backgroundColor: designTokens.color.blue.default.alpha.active.value,
                        },
                        '&:focus-visible': {
                            color: theme.palette.blue.light,
                            textDecoration: 'underline',
                            textUnderlineOffset: 2,
                        },
                    },
                },
            ], false),
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=buttonTheme.js.map